/* eslint-disable react/jsx-indent */
import React, {
  // useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import moment from 'moment';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {
  corruptedFile,
  eye,
  onboardEmpty,
  ongoingIc,
  toolTip,
} from '../../assets/images/images';
import {
  Loader,
  PageLimit,
  Pagination,
  PrimaryButton,
  SearchInput,
  TableLayout,
  SecondaryButton,
} from '../../components';
import {Constants} from '../../helpers';
import * as Actions from '../../store/actions';
import {PageContext, TourContext} from '../../helpers/context';
import EmptyState from '../../components/EmptyState';
import VerificationWrapper from './VerificationWrapper';
import {VerificationsTour} from '../../components/Tour';
import {getStatusTextAndStyles} from '../../helpers/getStatusTextAndStyles';
import VerificationLayout from './VerificationLayout';
// import {useWidgetFlows} from '../../hooks/useWidgetFlows';
import {useAllApps} from '../../hooks/useApps';
import {handleSetIds, getFilterOptions, getCommentDisplay} from './utils';
import {OverviewAnalytics} from './OverviewAnalytics';
import FilterV2 from '../../components/FilterV2';
import PageNumber from '../../components/PageNumber';
import {dateRanges} from 'helpers/getDateRange';

function Verifications({children, isChild = false, count}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [searchText, setSearchText] = useState('');
  const [showFilter, setShowFilter] = useState(true);
  const [filterParams, setFilterParams] = useState({
    app_ids: undefined,
    status: undefined,
    type: undefined,
    mode: undefined,
    date: 'seven_days',
    dateRange: dateRanges.seven_days(),
    term: undefined,
  });

  const navigate = useNavigate();
  // const {widgetFlows, isLoading} = useWidgetFlows();
  const dispatch = useDispatch();
  const {setPageName} = useContext(PageContext);

  const {
    verifications: {verifications, loading, exportLoading},
    auth: {userDetails},
  } = useSelector(state => ({
    verifications: state?.verifications,
    auth: state?.auth,
  }));
  const {tourState, updateTourState} = useContext(TourContext);

  // const getFlowName = useCallback(
  //   flowId => widgetFlows?.find(flow => flow.value === flowId)?.name,
  //   [widgetFlows],
  // );
  localStorage.removeItem('verificationList');

  useEffect(() => {
    setPageName('verifications');
  }, [setPageName]);

  const pageClick = selected => {
    setCurrentPage(selected);
  };

  const {userApps, appIds, isLoading: appsLoading} = useAllApps();

  const filterOptions = useMemo(() => {
    const options = getFilterOptions(userApps);
    return options.map(option => ({
      key: option.name,
      label: option.title,
      type: 'select',
      options: option.values,
      multiSelect: option.name !== 'status',
    }));
  }, [userApps]);

  const handleFilterChange = values => {
    const appIds = values.app_ids;
    const dateRange = values.dateRange;

    setFilterParams({
      app_ids: appIds,
      status: values.status,
      type: values.type,
      mode: values.mode,
      dateRange: dateRange,
      term: searchText,
    });
    setCurrentPage(1);
  };

  useEffect(() => {
    const apiParams = {
      page: currentPage,
      limit,
      appIds: filterParams.app_ids?.length > 0 ? filterParams.app_ids : appIds,
    };

    if (searchText) {
      apiParams.term = searchText;
    }

    if (filterParams.status) {
      apiParams.status = filterParams.status;
    }
    if (filterParams.type) {
      apiParams.type = filterParams.type.join(',');
    }
    if (filterParams.mode) {
      apiParams.mode = filterParams.mode.join(',');
    }

    if (filterParams.dateRange) {
      apiParams.start = filterParams.dateRange.start;
      apiParams.end = filterParams.dateRange.end;
    }

    !appsLoading &&
      userApps &&
      appIds &&
      !isChild &&
      dispatch(Actions?.getVerifications(apiParams));
  }, [
    userApps,
    currentPage,
    limit,
    appsLoading,
    appIds,
    isChild,
    dispatch,
    searchText,
    filterParams,
  ]);

  const verificationsData = useMemo(
    () => (verifications ? verifications?.data : []),
    [verifications],
  );

  const getVerificationsWithSearch = (text, appIds) => {
    const apiParams = {
      page: 1,
      limit,
      term: text,
      appIds: appIds || filterParams.app_ids || appIds,
    };
    setCurrentPage(1);
    dispatch(Actions?.getVerifications(apiParams));
  };

  const clearSearch = () => {
    setSearchText('');
    setCurrentPage(1);
    getVerificationsWithSearch('', appIds);
  };

  const canExport =
    userDetails?.permissions?.onboardPermissions?.exportVerifications;

  const handleExport = () => {
    const apiParams = {
      limit,
      appIds: filterParams.app_ids || appIds,
    };

    if (searchText) {
      apiParams.term = searchText;
    }
    if (filterParams.status) {
      apiParams.status = filterParams.status;
    }
    if (filterParams.type) {
      apiParams.type = filterParams.type.join(',');
    }
    if (filterParams.mode) {
      apiParams.mode = filterParams.mode.join(',');
    }

    if (filterParams.dateRange) {
      apiParams.start = filterParams.dateRange.start;
      apiParams.end = filterParams.dateRange.end;
    }

    dispatch(Actions?.exportVerifications(apiParams));
  };

  const isFiltered = verificationsData?.length === 0 && !loading && searchText;

  return (
    <VerificationWrapper>
      {tourState?.verifications_tour ? (
        <VerificationsTour
          updateTourState={updateTourState}
          DATA={verificationsData}
          loading={loading}
        />
      ) : null}

      <VerificationLayout count={count}>
        {children ?? (
          <>
            <div className="mx-[-32px] px-8 py-2  border border-transparent border-b-[#E4E4E6]">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <SearchInput
                    onChange={text => {
                      setSearchText(text);
                      if (text) {
                        getVerificationsWithSearch(text, appIds);
                        setFilterParams({...filterParams, term: text});
                      } else {
                        clearSearch();
                      }
                    }}
                    defaultValue={searchText}
                    placeholder="Search by name, or, reference ID"
                  />
                  <SecondaryButton
                    buttonText="Filter"
                    onClick={() => setShowFilter(!showFilter)}
                  />
                </div>

                <PrimaryButton
                  buttonText="Export"
                  className="hidden sm:flex"
                  onClick={handleExport}
                  loading={exportLoading}
                  disabled={exportLoading || !canExport}
                />

                <div
                  className="fixed bottom-0 left-0 right-0 z-10 px-4 py-2 overflow-x-hidden sm:hidden bg-white80"
                  style={{boxShadow: '0px -1px 8px rgba(51, 52, 66, 0.25)'}}
                >
                  <PrimaryButton
                    buttonText="Export"
                    xPadding="p-[35px]"
                    className="w-full bottom-2"
                    disabled
                  />
                </div>
              </div>
            </div>

            <div
              className={`filter-slide-container ${showFilter ? 'open' : ''}`}
            >
              <FilterV2
                filters={filterOptions}
                onFilterChange={handleFilterChange}
                initialValues={filterParams}
              />
            </div>

            <OverviewAnalytics filterParams={filterParams} />

            <TableLayout negativeMargins>
              <thead className="font-semibold uppercase text-small">
                <tr className="bg-white80">
                  <th className="pl-4 sm:pl-6 xl:pl-8 h-11 font-medium text-left text-small text-[#5C688E] whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <span>name</span>
                    </div>
                  </th>

                  <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <span>Reference ID</span>
                    </div>
                  </th>
                  <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <span>status</span>
                    </div>
                  </th>

                  <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <span>Reason</span>
                    </div>
                  </th>

                  <th className="pl-0 font-medium text-left h-11 text-small text-[#5C688E] whitespace-nowrap">
                    <div className="flex items-center gap-1">
                      <span>Date/Time created</span>
                    </div>
                  </th>
                  <th></th>
                </tr>
              </thead>

              <tbody>
                <tr>
                  <td colSpan={8}>
                    {loading ? (
                      <Loader height={45} />
                    ) : isFiltered ? (
                      <EmptyState
                        body="This search did not return any data, try using different values."
                        src={corruptedFile}
                        height={45}
                        noBtn
                      />
                    ) : !loading &&
                      !verificationsData.length &&
                      !searchText &&
                      (!verifications || !appIds) ? (
                      <EmptyState
                        body="Identify your users by viewing their verification details"
                        src={onboardEmpty}
                        height={45}
                        buttonText="Go to Verification Flow"
                        onClick={() => navigate('/easy-onboard')}
                      />
                    ) : !loading && verificationsData?.length === 0 ? (
                      <EmptyState
                        body="No verifications found."
                        src={corruptedFile}
                        noBtn
                        height={35}
                      />
                    ) : null}
                  </td>
                </tr>
              </tbody>

              <tbody className="text-sm bg-white">
                {!loading &&
                  verificationsData &&
                  verificationsData.map((verification, i) => {
                    const commentProps = getCommentDisplay(verification);
                    return (
                      <tr
                        className="border-[0.5px] border-[#E4E3EC] cursor-pointer"
                        key={i}
                        onClick={() => {
                          navigate(
                            Constants.PAGES_URL.VERIFICATIONS_BIO_DATA?.replace(
                              ':slug',
                              verification?.verification_id,
                            ),
                            {
                              state: {
                                sessionId: verification?.verification_id,
                              },
                            },
                          );
                          handleSetIds(verification);
                        }}
                      >
                        <td className="p-4 pl-4 sm:pl-6 xl:pl-8  text-body whitespace-nowrap">
                          {verification.first_name
                            ? `${verification.first_name} ${verification.last_name} ${verification.middle_name}`
                            : verification.business_name
                            ? verification.business_name
                            : '-'}
                        </td>

                        <td className="p-4 pl-0  text-body whitespace-nowrap">
                          {verification?.reference_id}
                        </td>
                        <td className="p-4 pl-0 whitespace-nowrap">
                          <div
                            className={`uppercase pt-[5px] pb-[3px] px-2 text-xs font-medium rounded-full w-fit flex items-start gap-[2px] ${
                              getStatusTextAndStyles(
                                verification?.status?.toLowerCase(),
                              ).styles
                            }`}
                          >
                            {
                              getStatusTextAndStyles(
                                verification?.status?.toLowerCase(),
                              ).text
                            }
                            {verification?.status?.toLowerCase() ===
                              'ongoing' && (
                              <img
                                src={ongoingIc || '/placeholder.svg'}
                                alt=""
                              />
                            )}
                          </div>
                        </td>
                        <td className="p-4 pl-0  text-body whitespace-nowrap relative">
                          <div className="w-full group flex items-center">
                            {commentProps?.mainText}

                            {commentProps?.showTooltip && (
                              <div className="group flex items-center">
                                <img
                                  src={toolTip}
                                  alt="tooltip"
                                  className="cursor-pointer"
                                />
                                <div className="hidden group-hover:block text-wrap w-auto bg-grey-50 h-fit absolute bottom-full text-center top-[25px] right-0 text-[#5C688E] z-50 text-[12px] rounded p-2">
                                  <p>{commentProps?.fullText}</p>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="p-4 pl-0 text-tiny text-body whitespace-nowrap">
                          {moment(verification?.datetime).format(
                            'Do MMM, YYYY h:mm A',
                          )}
                        </td>
                        <td className="p-4 pl-0 whitespace-nowrap">
                          <div className="flex items-center gap-4">
                            <button title="View" className="h-4 aspect-square">
                              <img src={eye} alt="" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
              </tbody>
            </TableLayout>

            {!loading && verificationsData && verificationsData.length > 0 && (
              <div className="flex flex-wrap items-center justify-between gap-4 sm:gap-0 bg-white80 mx-[-32px] px-8 py-[18px] border-[0.5px] border-y-[#E4E3EC] border-transparent">
                <PageNumber
                  currentPage={+currentPage}
                  limit={limit}
                  totalCount={verifications?.meta?.total_count}
                />

                <div className="flex items-center gap-5">
                  <PageLimit
                    onLimitChange={setLimit}
                    total={verifications && verifications?.meta?.total_count}
                    length={verificationsData?.length}
                    limit={limit}
                  />

                  <Pagination
                    total={
                      verifications &&
                      Math.ceil(verifications?.meta?.total_count / limit)
                    }
                    current={+currentPage}
                    onPageChange={activePage => {
                      pageClick(activePage);
                    }}
                  />
                </div>
              </div>
            )}
          </>
        )}
      </VerificationLayout>
    </VerificationWrapper>
  );
}

export default Verifications;
